<template>
  <div class="n-units-container">
    <field-input v-model="internalValueNUnits1"
                 label="隠れ層１" :name="hyperParamSummary.hyperParamId" :value="nUnits1"
                 :placeholder="hyperParamSummary.defaultVal"
                 :validate="validate" data-vv-value-path="nUnits1" validateLabel="隠れ層１"></field-input>
    <field-input v-model="internalValueNUnits2"
                 label="隠れ層２" :name="hyperParamSummary.hyperParamId" :value="nUnits2"
                 :placeholder="hyperParamSummary.defaultVal"
                 :validate="validate" data-vv-value-path="nUnits2" validateLabel="隠れ層２"></field-input>
    <field-input v-model="internalValueNUnits3"
                 label="隠れ層３" :name="hyperParamSummary.hyperParamId" :value="nUnits3"
                 :placeholder="hyperParamSummary.defaultVal"
                 :validate="validate" data-vv-value-path="nUnits3" validateLabel="隠れ層３"></field-input>
  </div>
</template>

<script lang="js">
import FieldInputCmp from '../input.vue'
import { HyperParamSummary } from '../../../../defines/hyper-param'

export default {
  name: 'NUnitsCmp',
  components: {
    'field-input': FieldInputCmp
  },
  props: {
    hyperParamSummary: HyperParamSummary,
    nUnits1: '',
    nUnits2: '',
    nUnits3: '',
    validate: null
  },
  computed: {
    internalValueNUnits1: {
      get () {
        return this.nUnits1
      },
      set (newValue) {
        this.$emit('change', 'n_unit_1', newValue)
      }
    },
    internalValueNUnits2: {
      get () {
        return this.nUnits2
      },
      set (newValue) {
        this.$emit('change', 'n_unit_2', newValue)
      }
    },
    internalValueNUnits3: {
      get () {
        return this.nUnits3
      },
      set (newValue) {
        this.$emit('change', 'n_unit_3', newValue)
      }
    }
  }
}

</script>

<style scoped>
  .n-units-container {
    display: flex;
    flex-direction: column;
  }

  .n-units-container >>> div:not(:first-child) {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/hyper-param/n-units.vue